import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import LogRepository from '@/shared/http/repositories/access/administrativelog'
import LogModel from '@/shared/models/access/administrativelogmodel'
import LogForms from './administrativelog-form'

export default {
  name: 'administrativelog',
  mixins: [ActionsForm],
  data () {
    return {
      data: LogModel,
      form: LogForms,
      en: en,
      es: es,
      ptBR: ptBR,
      objListLog: [],
      objAction: [
        { 'id': 0, 'name': this.$lang.All },
        { 'id': 1, 'name': this.$lang.Insert },
        { 'id': 2, 'name': this.$lang.Update },
        { 'id': 3, 'name': this.$lang.Delete }
      ]
    }
  },
  components: {
    Datepicker
  },
  methods: {
    onLoad () {
      loading.push()
      LogRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSearch () {
      loading.push()
      this.data.tablename = 'RegulationAuto'
      LogRepository.Search(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.data)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      LogRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      LogRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      LogRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/log/administrativelog.js